export default {
  places: [
    {
      imageUrl: '/img/Outlet.jpg',
      title: 'The Outlet Shoppes',
      description: 'Colorful, contemporary outlet mall with a food court, kids’ splash pad & free shuttle service.'
    },
    {
      imageUrl: '/img/Fountains.jpg',
      title: 'The Fountains at Farah',
      description: 'There are many shops to visit with a nice outdoor environment.'
    },
    {
      imageUrl: '/img/Jacinto.jpg',
      title: 'San Jacinto Plaza',
      description: 'San Jacinto Plaza is a historic park located on the corner of Oregon and Mills in the heart of Downtown El Paso, Texas.'
     },
     {
      imageUrl: '/img/Zoo.jpg',
      title: 'El Paso Zoo',
      description: 'The El Paso Zoo is a zoo located in El Paso, Texas. The 35-acre facility houses animals representing over 220 species, including such critically endangered species as the Amur leopard and the Aruba rattlesnake.'
     },
     {
      imageUrl: '/img/Cafe-Central.jpg',
      title: 'Cafe Central',
      description: 'Southwestern-accented, eclectic fine dining in refined dining room, gated courtyard or luxe lounge.'
     },
     {
      imageUrl: '/img/Southwest.jpg',
      title: 'Southwest University Park',
      description: 'Southwest University Park is a baseball stadium in El Paso, Texas. Primarily used for Minor League Baseball, it is the home of the El Paso Chihuahuas of the Triple-A Pacific Coast League'
     },
     {
      imageUrl: '/img/Playland.jpg',
      title: 'Western Playland',
      description: 'Western Playland is a 30-acre amusement park located in Sunland Park, New Mexico. It was located in Ascarate Park in El Paso, Texas from 1960 until 2006, but after conflicts with El Paso County, owner'
     },
     {
      imageUrl: '/img/TopGolf.jpg',
      title: 'Topgolf',
      description: 'Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.'
     },
     {
      imageUrl: '/img/Wet-N-Wild.jpg',
      title: 'Wet N Wild Waterworldr',
      description: 'Wet N Wild Waterworld is a 60 acre waterpark featuring over 25 rides and attractions and a canopy of mature shade trees. It is located at 8804 S. Desert in Anthony, Texas, a small town in between El Paso, Texas, and Las Cruces, New Mexico.'
     },
     {
      imageUrl: '/img/Red-Sands.jpg',
      title: 'Rent an ATV Off-Road Adventures at Red Sands',
      description: 'Take out your pick-up or motorcycles come and have fun in the desert'
     },
     {
      imageUrl: '/img/Franklin.jpg',
      title: 'Franklin mountains',
      description: 'The Franklin Mountains of Texas are a small range that extend from El Paso, Texas north into New Mexico. The Franklins were formed due to crustal extension related to the Cenozoic Rio Grande rift.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/requests/places.js